import { render } from "./Col4.vue?vue&type=template&id=f338c142"
import script from "./Col4.vue?vue&type=script&lang=js"
export * from "./Col4.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__